import {
  Inline,
  Stack,
  Text,
  useDevice,
  Viewport,
  FAQs,
  AccordionItemType,
} from '@treatwell/ui';
import clsx from 'clsx';
import React from 'react';
import styles from './FAQsSection.module.css';

export type CmsFAQsType = {
  title: string;
  description?: string;
};

type FAQsSectionType = {
  header: CmsFAQsType;
  faqs: AccordionItemType[];
  showAllFAQsButtonLabel: string;
};

const FAQsHeader = ({
  title,
  description,
}: {
  title: CmsFAQsType['title'];
  description: CmsFAQsType['description'];
}) => {
  const { isMobile, isDesktop } = useDevice();

  return (
    <Stack as="header" align="start" space="2xl" className={styles.header}>
      <Viewport device={['mobile', 'tablet']} serverRender={isMobile}>
        <Text as="h2" type="xlHeader">
          {title}
        </Text>
      </Viewport>
      <Viewport device="desktop" serverRender={isDesktop}>
        <Text as="h2" type="mdHero">
          {title}
        </Text>
        {description && (
          <Text as="p" type="body">
            <span dangerouslySetInnerHTML={{ __html: description }} />
          </Text>
        )}
      </Viewport>
    </Stack>
  );
};

export const FAQsSection = ({
  header,
  faqs,
  showAllFAQsButtonLabel,
  className,
}: FAQsSectionType & { className?: string }) => {
  const { isMobile, isDesktop } = useDevice();

  return (
    <section className={clsx(styles.root, className)}>
      <Viewport device={['mobile', 'tablet']} serverRender={isMobile}>
        <Stack space="xl">
          <FAQsHeader title={header.title} description={header.description} />
          <FAQs faqs={faqs} showAllFAQsButtonLabel={showAllFAQsButtonLabel} />
        </Stack>
      </Viewport>
      <Viewport device="desktop" serverRender={isDesktop}>
        <Inline justify="between" space="2xl" align="start">
          <FAQsHeader title={header.title} description={header.description} />
          <div className={styles.faqsWrapper}>
            <FAQs faqs={faqs} showAllFAQsButtonLabel={showAllFAQsButtonLabel} />
          </div>
        </Inline>
      </Viewport>
    </section>
  );
};
